// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'view-design/dist/styles/iview.css'
import ElementUI from 'element-ui'
import Vue2OrgTree from 'vue2-org-tree'
// import VueQuillEditor from 'vue-quill-editor'
import '../static/UEditor/ueditor.config'
import '../static/UEditor/ueditor.all.js'
import '../static/UEditor/lang/zh-cn/zh-cn.js'
import '../static/UEditor/ueditor.parse.min.js'
import store from './store/store.js'
import * as filters from './utils/filters.js'
import 'default-passive-events'

import '@/assets/css/baseReset.css'
import '@/assets/css/iconfont.css'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/element-variables.scss'
import '@/assets/scss/_elementReset.scss'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import '@/assets/scss/_common.scss'
import '@/store/permission.js'
// import '@/utils/ipConfig.js'
import echarts from 'echarts'
import Moment from 'moment'
import 'echarts-liquidfill'
import FullCalendar from 'vue-fullcalendar'
import { operationBar, searchBar, searchBarChocie, popup, GPagination } from '@/components/operrationOrsearch.js'
import Print from 'vue-print-nb'

Vue.use(Print)
Vue.use(FullCalendar)
Vue.use(popup)
Vue.use(operationBar)
Vue.use(searchBar)
Vue.use(searchBarChocie)
Vue.use(GPagination)
Vue.use(ElementUI)
Vue.use(Vue2OrgTree)
// Vue.use(VueQuillEditor)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = Moment
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm') {
  return Moment(dataStr).format(pattern)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js